import { userConstants } from '../constants';
import { UserResponse } from '../py-generated/datalouder/third_party_login/types';
import { userService } from '../services';
import { alertActions } from '.';
import { generalErrorHandler } from './utils';

export default {
  login,
  logout,
  register,
  updateUser,
  refresh,
  resendVerificationCommunicate, // remove it, doesn't need to be global
  sendResetPassword,
  resetPassword,
  fetchProfilePermission,
  updateProfile,
  loginSuccess,
};

function login(email, password, remember = false) {
  return dispatch => {
    dispatch(request());

    return userService.login(email, password, remember).then(
      user => {
        dispatch(loginSuccess(user));
      },
      generalErrorHandler(dispatch, (error: Error) => {
        dispatch(failure(error.toString()));
      })
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function loginSuccess(user) {
  return { type: userConstants.LOGIN_SUCCESS, user };
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function register(
  user: {
    login: string;
    password: string;
    alias: string;
    publicName: string;
  },
  provider?: string,
  accessToken?: string
) {
  return dispatch => {
    dispatch(request(user));

    return userService.register(user, provider, accessToken).then(
      user => {
        dispatch(success(user));
        dispatch(alertActions.success('Registration successful'));
      },
      generalErrorHandler(dispatch, (error: Error) => {
        dispatch(failure(error.toString()));
      })
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function updateUser(user: UserResponse, alias: string, login: string) {
  return dispatch => {
    dispatch(request(user));

    return userService.updateUser(alias, login).then(
      user => {
        dispatch(success(user));
        dispatch(alertActions.success('Update profile successful'));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(user, error.toString()))
      )
    );
  };

  function request(user) {
    return { type: userConstants.UPDATE_PROFILE_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.UPDATE_PROFILE_SUCCESS, user };
  }
  function failure(user, error) {
    return { type: userConstants.UPDATE_PROFILE_FAILURE, user, error };
  }
}

function refresh() {
  return dispatch => {
    dispatch(request());
    return userService.refresh().then(
      user => {
        dispatch(success(user));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: userConstants.REFRESH_REQUEST };
  }
  function success(user) {
    return { type: userConstants.REFRESH_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REFRESH_FAILURE, error };
  }
}

function resendVerificationCommunicate() {
  return dispatch => {
    dispatch(request());

    return userService.resendVerificationCommunicate().then(
      () => {
        dispatch(success());
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: userConstants.RESEND_VERI_REQUEST };
  }
  function success() {
    return { type: userConstants.RESEND_VERI_SUCCESS };
  }
  function failure(error) {
    return { type: userConstants.RESEND_VERI_FAILURE, error };
  }
}

function sendResetPassword(email) {
  return dispatch => {
    dispatch(request());

    return userService.sendResetPassword(email).then(
      ({ prefix }) => {
        dispatch(success(prefix));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: userConstants.SEND_RESETPASS_REQUEST };
  }
  function success(prefix: string) {
    return { type: userConstants.SEND_RESETPASS_SUCCESS, prefix };
  }
  function failure(error) {
    return { type: userConstants.SEND_RESETPASS_FAILURE, error };
  }
}

function resetPassword(email, verificationCode, password) {
  return dispatch => {
    dispatch(request());

    return userService.resetPassword(email, verificationCode, password).then(
      () => {
        dispatch(success());
        dispatch({ type: userConstants.SEND_RESETPASS_RESET });
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: userConstants.RESETPASS_REQUEST };
  }
  function success() {
    return { type: userConstants.RESETPASS_SUCCESS };
  }
  function failure(error) {
    return { type: userConstants.RESETPASS_FAILURE, error };
  }
}

function fetchProfilePermission() {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());

    return userService.profilePermission().then(
      data => {
        dispatch(success(data));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: userConstants.FETCH_PROFILE_PERMISSION_REQUEST };
  }
  function success(permission) {
    return { type: userConstants.FETCH_PROFILE_PERMISSION_SUCCESS, permission };
  }
  function failure(error) {
    return { type: userConstants.FETCH_PROFILE_PERMISSION_FAILURE, error };
  }
}

function updateProfile(name: string, stockListPermission: string) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());

    return userService
      .updateProfile(name, stockListPermission)
      .then(() => userService.profilePermission())
      .then(
        data => {
          dispatch(success(data));
        },
        generalErrorHandler(dispatch, error =>
          dispatch(failure(error.toString()))
        )
      );
  };

  function request() {
    return { type: userConstants.UPDATE_PROFILE_PERMISSION_REQUEST };
  }
  function success(permission) {
    return {
      type: userConstants.UPDATE_PROFILE_PERMISSION_SUCCESS,
      permission,
    };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_PROFILE_PERMISSION_FAILURE, error };
  }
}
